import styled, { css } from 'styled-components'

import { brkmax } from '../theme'

import { Dialog } from './Dialog'

export const ContentDialog = styled(Dialog)`
  ${brkmax(
    0,
    css`
      .ant-modal-content {
        display: flex;
        flex-direction: column;
      }
      .ant-modal-header {
        order: 1;
      }
      .ant-modal-body {
        order: 2;
      }
      .ant-modal-footer {
        order: 3;
      }
    `
  )}
`
